import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login_box" }
const _hoisted_2 = { class: "login_content" }
const _hoisted_3 = { class: "content_box" }
const _hoisted_4 = { class: "login_wrap_left" }
const _hoisted_5 = { class: "swiper_box" }
const _hoisted_6 = { class: "login_wrap_right" }
const _hoisted_7 = { class: "wrap_from_top" }
const _hoisted_8 = { class: "form_item" }
const _hoisted_9 = { class: "wrap_from_bottom" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "form_input" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "form_bottom" }
const _hoisted_14 = { class: "wrap_form_btn" }
const _hoisted_15 = { class: "wrap_active" }
const _hoisted_16 = { class: "wrap_button" }
const _hoisted_17 = { class: "agreement_check" }
const _hoisted_18 = { class: "code_box" }
const _hoisted_19 = { class: "code_box_bode" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "code_mask"
}
const _hoisted_22 = {
  key: 1,
  class: "code_mask_txt"
}
const _hoisted_23 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Rotation = _resolveComponent("Rotation")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Rotation)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createVNode(_component_a_form, { class: "right_conteng" }, {
            default: _withCtx(() => [
              _cache[21] || (_cache[21] = _createElementVNode("h2", null, "欢迎登录", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_input, {
                    style: {"font-size":"14px","height":"45px"},
                    class: "form_item_name",
                    value: _ctx.formData.username,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.username) = $event)),
                    placeholder: "请输入手机号",
                    onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.isShowform)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_a_input_password, {
                            style: {"font-size":"14px","height":"45px"},
                            class: "form_input_pass",
                            value: _ctx.formData.password,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.password) = $event)),
                            placeholder: "请输入密码",
                            onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;",
                            autocomplete: "",
                            onKeyup: _withKeys(_ctx.login, ["enter"])
                          }, null, 8, ["value", "onKeyup"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_a_input, {
                            style: {"font-size":"14px","height":"45px","border-radius":"4px"},
                            class: "form_bottom_valid",
                            placeholder: "请输入验证码",
                            value: _ctx.formData.code,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.code) = $event)),
                            onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                          }, null, 8, ["value"]),
                          _createElementVNode("div", _hoisted_14, [
                            _withDirectives(_createElementVNode("button", {
                              class: "wrap_form_button",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getCode()))
                            }, "获取验证码", 512), [
                              [_vShow, _ctx.isShowcode]
                            ]),
                            _withDirectives(_createElementVNode("span", { class: "wrap_form_vaild" }, " 获取验证码(" + _toDisplayString(_ctx.count) + ") ", 513), [
                              [_vShow, !_ctx.isShowcode]
                            ])
                          ])
                        ])
                      ]))
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "awsc" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_router_link, { to: "/register" }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("p", { style: {"color":"'#808080'"} }, "免费注册", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/lostpass" }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("p", { style: {"color":"#808080"} }, "忘记密码", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.login()))
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("登 录", -1)
                  ]))]),
                  _: 1
                }),
                (_ctx.isShowform)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowform = !_ctx.isShowform))
                    }, "验证码登录"))
                  : (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowform = !_ctx.isShowform))
                    }, "密码登录"))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_a_checkbox, {
                  checked: _ctx.agreementCheckbox,
                  "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.agreementCheckbox) = $event))
                }, null, 8, ["checked"]),
                _cache[15] || (_cache[15] = _createTextVNode(" 我已阅读并接受 ", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("a", {
                  href: "https://www.qing.tv/law/service-agreement",
                  target: "blank"
                }, "服务协议", -1)),
                _cache[17] || (_cache[17] = _createTextVNode("、 ", -1)),
                _cache[18] || (_cache[18] = _createElementVNode("a", {
                  href: "https://www.qing.tv/law/privacy",
                  target: "blank"
                }, "隐私政策", -1)),
                _cache[19] || (_cache[19] = _createTextVNode("、 ", -1)),
                _cache[20] || (_cache[20] = _createElementVNode("a", {
                  href: "https://www.qing.tv/law/anchor-specification",
                  target: "blank"
                }, "网络主播行为规范", -1))
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, !_ctx.isShowQrcode]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_18, [
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "code_box_title" }, [
              _createElementVNode("h2", null, "请使用APP扫码")
            ], -1)),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass(["code_img", { filter: _ctx.codeLoginData.showMask || !_ctx.loginQrCode || !_ctx.clientId }])
              }, [
                (_ctx.qrcodeUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.qrcodeUrl
                    }, null, 8, _hoisted_20))
                  : _createCommentVNode("", true)
              ], 2),
              (_ctx.codeLoginData.showMask || !_ctx.loginQrCode || !_ctx.clientId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (!_ctx.loginQrCode || !_ctx.clientId)
                      ? (_openBlock(), _createBlock(_component_a_spin, {
                          key: 0,
                          size: "large"
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.codeLoginData.status === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _cache[22] || (_cache[22] = _createTextVNode(" 扫码完成，请在APP内确认 ", -1)),
                          (_ctx.codeLoginCount)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, "(" + _toDisplayString(_ctx.codeLoginCount) + "S内未确认登录，重新生成二维码)", 1))
                            : _createCommentVNode("", true),
                          (_ctx.codeLoginCount === 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clickRefresh && _ctx.clickRefresh(...args)))
                              }, "(二维码已过期，请点击刷新)"))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.codeLoginData.status === 2)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "code_mask_txt",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clickRefresh && _ctx.clickRefresh(...args)))
                        }, [...(_cache[23] || (_cache[23] = [
                          _createTextVNode(" 二维码已过期", -1),
                          _createElementVNode("br", null, null, -1),
                          _createTextVNode("请点击刷新 ", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.codeLoginData.status === 3)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: "code_mask_txt",
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clickRefresh && _ctx.clickRefresh(...args)))
                        }, [...(_cache[24] || (_cache[24] = [
                          _createTextVNode(" 二维码已被使用", -1),
                          _createElementVNode("br", null, null, -1),
                          _createTextVNode("请点击刷新 ", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, _ctx.isShowQrcode]
          ])
        ])
      ])
    ])
  ]))
}